/**
 * Token request / recharge / usage management is limited to built-in admin roles.
 * group_profile_order.id: 0 = Sparta Admin, 23 = Lease Admin
 * (Lease Manager and custom roles are excluded — not grantable via custom permissions.)
 */
export const TOKEN_ADMIN_PROFILE_IDS = [0, 23];

export function canManageTokens(permission) {
  return TOKEN_ADMIN_PROFILE_IDS.includes(permission?.group_profile_order?.id);
}
